import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {IGetDataReturn, IGetSearchReturn, IHttpSetting} from '../interface/dataset-params';
import {GlobalObjectService} from '../class/global-obj';

@Injectable({
    providedIn: 'root'
})
export class HttpFormDataService {

    constructor(private http: HttpClient) {
    }

    toHttpParams(params) {
        return Object.getOwnPropertyNames(params)
            .reduce((p, key) => p.set(params[key].key, params[key].value), new HttpParams());
    }

    public getDatasetParams(setting: IHttpSetting, datasetId: any)
        : Observable<IGetDataReturn> {

        const body = {
            func: '__dsparam',
            dsid: datasetId
        };
        return this.http.post(setting.urls.dataset_url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public searchDataset(setting: IHttpSetting, datasetId: any, searchText: string, shadowFieldValues = null)
        : Observable<IGetSearchReturn> {

        const body = {
            func: '__dsparam',
            dsid: datasetId,
            search: searchText,
            shadow: shadowFieldValues
        };
        return this.http.post(setting.urls.dataset_url, JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public getDatasetParamsWMultiple(setting: IHttpSetting, multipleDatasetId: any, multipleFieldName: string)
        : Observable<IGetDataReturn> {

        const body = {
            func: '__dsparamWmultiple',
            dsid: multipleDatasetId,
            mfield: multipleFieldName
        };
        return this.http.post(setting.urls.dataset_url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


    public getDatasetRecord(setting: IHttpSetting, datasetId: any, recordId: any, ViewOrNot)
        : Observable<IGetDataReturn> {

        const body = {
            func: ViewOrNot !== 'VIEW' ? '__dsrecord' : '__dsrecordv',
            dsid: datasetId,
            rid: recordId
        };
        return this.http.post(setting.urls.dataset_url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public getSurveyQuestions(setting: IHttpSetting, datasetId: any, surveyId: any)
        : Observable<IGetDataReturn> {

        const body = {
            func: '__dsq',
            dsid: datasetId,
            sid: surveyId
        };
        return this.http.post(setting.urls.dataset_url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


    public appViewDetail(setting: IHttpSetting, appViewId: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_info',
            _id: appViewId
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/appview',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public appViewStepInfo(setting: IHttpSetting, appViewId: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_step_info',
            _id: appViewId
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/appview',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


    public coderunControlStep(setting: IHttpSetting, appViewId: any, stepId: number)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_cr_step',
            _id: appViewId,
            step: stepId
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/appview',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public callStepUpdateSet(setting: IHttpSetting, appViewId: any, recordId: any, updateSetId: number, stepId: number)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_call_updateset',
            _id: appViewId,
            rid: recordId,
            usid: updateSetId,
            step: stepId
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/appview',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    runCodeRunStep(setting: IHttpSetting, stepId, appViewId, recordId, eventAction): Observable<IGetDataReturn> {
        const body = {
            env: 'step',
            step: stepId,
            appview: appViewId,
            rid: recordId,
            event: eventAction
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/coderunbridge',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


    public getActivityforDataset(setting: IHttpSetting, datasetId: any, recordId: number)
        : Observable<IGetDataReturn> {

        const body = {
            func: '__dsactivity',
            dsid: datasetId,
            rid: recordId
        };
        return this.http.post(setting.urls.dataset_url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


    public partProducts(setting: IHttpSetting, partId: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_part_products',
            _id: 0,
            part_id: partId
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/dsactions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public bomProductVaraible(setting: IHttpSetting, productId: any, fieldName: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_bom_product_field',
            _id: 0,
            product_id: productId,
            field: fieldName
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/dsactions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public dashboard_calendar(setting: IHttpSetting, kpiuid: any, year: any, month: any, day: any, noCache)
        : Observable<IGetDataReturn> {
        const body = {
            kpiuid,
            year,
            month,
            day,
            noCache
        };
        const url = setting.urls.dashboard_url.replace(/\/+$/, '');
        return this.http.post(url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public dashboard_kpi(setting: IHttpSetting, kpiuid: any, noCache)
        : Observable<IGetDataReturn> {
        const body = {
            kpiuid,
            noCache
        };
        const url = setting.urls.dashboard_url.replace(/\/+$/, '');
        return this.http.post(url,
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public datasetInfo(datasetId: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_dataset',
            dsid: datasetId,
            _id: 0
        };


        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/formActions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


}
